// frontend/src/features/board/components/details/detailGrid/Activity.js
import React, { useState } from "react";
import { Box, FormControl, InputLabel, Select } from "@mui/material";
import {
  ForumOutlined,
  WorkHistoryOutlined,
  RestoreOutlined,
} from "@mui/icons-material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";

import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../../../components/Button/Button";
import AddWorklogCustomizedDialogs from "../../worklog/addWorklog/addWorklogDialog";
import commentIcon from "../../../../../styles/svg/commentIcon.svg";
import worklogIcon from "../../../../../styles/svg/worklogIcon.svg";
import historyIcon from "../../../../../styles/svg/historyIcon.svg";

function Activity({
  activeTab,
  handleActiveTab,
  isMobile,
  addWorklogPermission,
  cardId,
}) {
  const [addWorklog, setAddWorklog] = useState(false);
  return (
    <div
      className={`d-flex ${
        isMobile ? "mobile-activity-dropdown" : "right-btns"
      }`}
    >
      <div
        className={` ${
          isMobile ? "mobile-activity-message" : "activity-message"
        }`}
      >
        Activity
      </div>
      {isMobile ? (
        <Box sx={{ minWidth: 120 }} className="d-flex align-items-center">
          {activeTab === "worklog" && addWorklogPermission && (
            <AddCircleOutlinedIcon className="icon mobile-add-worklog-icon" onClick={()=> setAddWorklog(true)}/>
          )}
          {addWorklog && (
            <AddWorklogCustomizedDialogs
              cardId={cardId}
              addWorklog={addWorklog}
              setAddWorklog={setAddWorklog}
              heading={"Add Work Log"}
              buttonName={"Save"}
            />
          )}
          <FormControl
            variant="standard"
            fullWidth
            size="small"
            className="native-activity-select"
          >
            {/* <InputLabel id="demo-simple-select-label">
              {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
            </InputLabel> */}
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              label={activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
              onChange={(e) => handleActiveTab(e.target.value.toLowerCase())}
              defaultValue={"All"}
            >
              <CustomMenuItem
                value="All"
                onClick={() => handleActiveTab("all")}
              >
                All
              </CustomMenuItem>
              <CustomMenuItem
                value="Worklog"
                onClick={() => handleActiveTab("worklog")}
                className={`${
                  activeTab === "worklog"
                    ? "active-activity-tab"
                    : "mobile-activity-tab"
                }`}
              >
                <WorkHistoryOutlined className="icon" /> Worklogs
              </CustomMenuItem>
              <CustomMenuItem
                value="Comment"
                onClick={() => handleActiveTab("comment")}
                className={`${
                  activeTab === "comment"
                    ? "active-activity-tab"
                    : "mobile-activity-tab"
                }`}
              >
                <ForumOutlined className="icon" /> Comments
              </CustomMenuItem>
              <CustomMenuItem
                value="History"
                onClick={() => handleActiveTab("history")}
                className={`${
                  activeTab === "history"
                    ? "active-activity-tab"
                    : "mobile-activity-tab"
                }`}
              >
                <RestoreOutlined className="icon" /> History
              </CustomMenuItem>
            </Select>
          </FormControl>
        </Box>
      ) : (
        <div className="d-flex justify-content-center align-items-center activity-btn">
          <div className="show">Show:</div>
          <CustomButton
            className={`tab-btn ${
              activeTab === "all" ? "btn-active" : "detail-tab-btn"
            }`}
            variant="outlined"
            onClick={() => handleActiveTab("all")}
          >
            All
          </CustomButton>
          <CustomButton
            variant="outlined"
            className={`tab-btn ${
              activeTab === "worklog" ? "btn-active" : "detail-tab-btn"
            }`}
            onClick={() => handleActiveTab("worklog")}
          >
            <img className="icon" alt="icon" src={worklogIcon} />
            WORKLOG
          </CustomButton>
          <CustomButton
            variant="outlined"
            className={`tab-btn ${
              activeTab === "comment" ? "btn-active" : "detail-tab-btn"
            }`}
            onClick={() => handleActiveTab("comment")}
          >
            <img className="icon" src={commentIcon} alt="" />
            <div>COMMENTS</div>
          </CustomButton>
          <CustomButton
            className={`tab-btn ${
              activeTab === "history" ? "btn-active" : "detail-tab-btn"
            }`}
            variant="outlined"
            onClick={() => handleActiveTab("history")}
          >
            <img className="icon" src={historyIcon} alt="" />
            HISTORY
          </CustomButton>
        </div>
      )}
    </div>
  );
}

export default React.memo(Activity);
